var _path, _path2, _path3, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLine3(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 498,
    height: 494,
    viewBox: "0 0 498 494",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1064_2174)"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M364.092 422.031L361.842 425.158C369.214 433.685 376.082 442.689 382.262 451.819C414.462 499.386 432.576 557.835 437.649 630.527L441.472 631.18C436.296 557.303 417.831 497.823 384.943 449.261C378.636 439.916 371.593 430.772 364.059 422.045L364.092 422.031Z",
    fill: "#83E4FE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M137.43 180.584C139.389 186.981 141.567 193.342 143.783 199.419C148.074 211.045 152.902 222.18 158.116 232.46C166.614 249.227 176.373 264.241 187.208 277.152C190.714 281.357 194.381 285.388 198.139 289.167C218.19 309.41 241.803 326.3 266.816 344.211L267.813 344.919C280.879 354.282 295.73 364.934 310.124 376.363L311.649 372.523C297.183 361.017 282.28 350.334 269.161 340.938L268.164 340.231C243.36 322.447 219.904 305.651 200.19 285.749C196.555 282.079 192.978 278.171 189.563 274.088C179.084 261.564 169.562 246.932 161.286 230.606C156.2 220.54 151.486 209.678 147.257 198.294C145.045 192.322 142.957 186.084 141.002 179.792L137.463 180.57L137.43 180.584Z",
    fill: "#83E4FE"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M117.462 52.963C117.442 53.2916 117.364 85.6495 124.851 127.843L128.594 127.835C121.216 86.1842 121.317 54.351 121.303 54.0362L117.462 52.963Z",
    fill: "#83E4FE"
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M192.652 171.515C232.965 195.993 256.686 253.006 245.633 298.856C234.581 344.706 192.94 362.031 152.626 337.553C112.313 313.074 88.5918 256.062 99.6444 210.211C110.697 164.361 152.338 147.036 192.652 171.515Z",
    fill: "url(#paint0_radial_1064_2174)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M192.652 171.515C232.965 195.993 256.686 253.006 245.633 298.856C234.581 344.706 192.94 362.031 152.626 337.553C112.313 313.074 88.5918 256.062 99.6444 210.211C110.697 164.361 152.338 147.036 192.652 171.515Z",
    fill: "url(#paint1_radial_1064_2174)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M286.857 319.512C309.418 310.126 338.126 327.557 350.978 358.447C363.829 389.336 355.959 421.986 333.398 431.373C310.837 440.76 282.129 423.328 269.277 392.439C256.425 361.549 264.296 328.899 286.857 319.512Z",
    fill: "url(#paint2_radial_1064_2174)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M286.857 319.512C309.418 310.126 338.126 327.557 350.978 358.447C363.829 389.336 355.959 421.986 333.398 431.373C310.837 440.76 282.129 423.328 269.277 392.439C256.425 361.549 264.296 328.899 286.857 319.512Z",
    fill: "url(#paint3_radial_1064_2174)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M368.924 413.604C391.485 404.218 420.193 421.649 433.045 452.538C445.897 483.428 438.026 516.078 415.465 525.465C392.904 534.851 364.197 517.42 351.345 486.531C338.493 455.641 346.364 422.991 368.924 413.604Z",
    fill: "url(#paint4_radial_1064_2174)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M368.924 413.604C391.485 404.218 420.193 421.649 433.045 452.538C445.897 483.428 438.026 516.078 415.465 525.465C392.904 534.851 364.197 517.42 351.345 486.531C338.493 455.641 346.364 422.991 368.924 413.604Z",
    fill: "url(#paint5_radial_1064_2174)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_1064_2174",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(172.643 254.541) rotate(-22.5904) scale(71.2312 97.5268)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#93FFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#84E6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#69B6B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#508B8B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#3A6565",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#284545",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#192C2C",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#0E1818",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#060A0A",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#010202",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_1064_2174",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(172.643 254.541) rotate(-22.5904) scale(71.2312 97.5268)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#93FFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#84E6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#69B6B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#508B8B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#3A6565",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#284545",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#192C2C",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#0E1818",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#060A0A",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#010202",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_1064_2174",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(310.127 375.443) rotate(-22.5903) scale(44.2448 60.5781)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#93FFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#84E6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#69B6B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#508B8B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#3A6565",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#284545",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#192C2C",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#0E1818",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#060A0A",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#010202",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_1064_2174",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(310.127 375.443) rotate(-22.5903) scale(44.2448 60.5781)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#93FFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#84E6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#69B6B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#508B8B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#3A6565",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#284545",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#192C2C",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#0E1818",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#060A0A",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#010202",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_1064_2174",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(392.195 469.535) rotate(-22.5903) scale(44.2448 60.5781)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#93FFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#84E6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#69B6B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#508B8B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#3A6565",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#284545",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#192C2C",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#0E1818",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#060A0A",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#010202",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint5_radial_1064_2174",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(392.195 469.535) rotate(-22.5903) scale(44.2448 60.5781)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#93FFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#84E6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#69B6B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#508B8B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#3A6565",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#284545",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#192C2C",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#0E1818",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#060A0A",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#010202",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1064_2174"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 498,
    height: 494,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLine3);
export default __webpack_public_path__ + "static/media/line3.07c7d69cc56a8f50581478ead757c6fa.svg";
export { ForwardRef as ReactComponent };